function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["type", "name", "required", "requiredAsserts", "showOptional", "rules", "initialValue", "normalize", "mergeRules", "getValueFromEvent", "getValueProps", "extra", "help", "label", "previewLabel", "extraLabel", "copyValue", "selectValue", "span", "halfRow", "fullRow", "valuePropName", "dependencies", "asserts", "messageVariables", "requiredMessage", "previewFormater", "disabled", "ignore", "shouldRender", "valueFormater", "antdDependencies", "dateLimitationType", "absoluteRangeEnd", "absoluteRangeStart", "relativeRangeStart", "relativeRangeEnd", "validationCode", "shouldRenderCode"],
  _excluded2 = ["initialValue", "normalize", "rules", "extra", "help", "getValueFromEvent", "span", "valuePropName", "fullRow", "halfRow", "messageVariables", "requiredMessage", "previewFormater", "valueFormater", "required", "requiredMark", "className"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import invariant from 'invariant';
import Typography from "../typography";
import FormattedMessage from "../locale/formatted-message";
import moment from 'dayjs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var calcNamePath = function calcNamePath(parentName, name) {
  var names = [];
  if (parentName) {
    names.push(parentName);
  }
  if (name !== undefined) {
    names.push(name);
  }
  return names.flat();
};
export var testAssert = function testAssert(form, assert) {
  var field = assert.field,
    value = assert.value,
    operation = assert.operation;
  var v = form.getFieldValue(typeof field === 'string' ? field.split('.') : field);
  switch (operation) {
    case 'ne':
      if (v === value) return false;
      break;
    case 'in':
      if (!Array.isArray(value) || !value.includes(v)) return false;
      break;
    case 'ni':
      if (Array.isArray(value) && value.includes(v)) return false;
      break;
    case 'co':
      if (!Array.isArray(v) || !v.includes(value)) return false;
      break;
    case 'nc':
      if (Array.isArray(v) && v.includes(value)) return false;
      break;
    case 'lt':
      if (v === undefined || v >= value) return false;
      break;
    case 'le':
      if (v === undefined || v > value) return false;
      break;
    case 'gt':
      if (v === undefined || v <= value) return false;
      break;
    case 'ge':
      if (v === undefined || v < value) return false;
      break;
    case 'filled':
      return v !== undefined && v !== '' && !(Array.isArray(v) && !v.length);
    case 'unfilled':
      return v === undefined || v === '' || Array.isArray(v) && !v.length;
    case 'eq':
      return v === value;
    case 'co-every':
      {
        if (!Array.isArray(v) || !Array.isArray(value)) {
          return false;
        }
        return value.every(function (i) {
          return v.includes(i);
        });
      }
    case 'co-some':
      {
        if (!Array.isArray(v) || !Array.isArray(value)) {
          return false;
        }
        return value.some(function (i) {
          return v.includes(i);
        });
      }
    case 'every-in':
      {
        if (!Array.isArray(v) || !Array.isArray(value)) {
          return false;
        }
        return v.every(function (i) {
          return value.includes(i);
        });
      }
    case 'some-in':
      {
        if (!Array.isArray(v) || !Array.isArray(value)) {
          return false;
        }
        return v.some(function (i) {
          return value.includes(i);
        });
      }
    default:
      if (value !== undefined) return v === value;
      return v !== undefined;
  }
  return true;
};
var calcRequired = function calcRequired(required, form, requiredAsserts) {
  if (Array.isArray(requiredAsserts)) {
    return requiredAsserts.every(function (assert) {
      return form && testAssert(form, assert);
    });
  }
  return required;
};
export var calcFormItemProps = function calcFormItemProps(config, extraProps, form, parentName, validationCodeExtraParams) {
  var type = config.type,
    nameProp = config.name,
    _config$required = config.required,
    required = _config$required === void 0 ? true : _config$required,
    requiredAsserts = config.requiredAsserts,
    _config$showOptional = config.showOptional,
    showOptional = _config$showOptional === void 0 ? false : _config$showOptional,
    _config$rules = config.rules,
    propsRules = _config$rules === void 0 ? [] : _config$rules,
    initialValue = config.initialValue,
    normalize = config.normalize,
    _config$mergeRules = config.mergeRules,
    mergeRules = _config$mergeRules === void 0 ? true : _config$mergeRules,
    getValueFromEvent = config.getValueFromEvent,
    getValueProps = config.getValueProps,
    extra = config.extra,
    help = config.help,
    label = config.label,
    previewLabel = config.previewLabel,
    extraLabel = config.extraLabel,
    copyValue = config.copyValue,
    selectValue = config.selectValue,
    span = config.span,
    halfRow = config.halfRow,
    fullRow = config.fullRow,
    valuePropName = config.valuePropName,
    _config$dependencies = config.dependencies,
    dependencies = _config$dependencies === void 0 ? [] : _config$dependencies,
    _config$asserts = config.asserts,
    asserts = _config$asserts === void 0 ? [] : _config$asserts,
    messageVariables = config.messageVariables,
    requiredMessage = config.requiredMessage,
    previewFormater = config.previewFormater,
    disabled = config.disabled,
    ignore = config.ignore,
    shouldRender = config.shouldRender,
    valueFormater = config.valueFormater,
    antdDependencies = config.antdDependencies,
    dateLimitationType = config.dateLimitationType,
    absoluteRangeEnd = config.absoluteRangeEnd,
    absoluteRangeStart = config.absoluteRangeStart,
    relativeRangeStart = config.relativeRangeStart,
    relativeRangeEnd = config.relativeRangeEnd,
    _config$validationCod = config.validationCode,
    validationCode = _config$validationCod === void 0 ? [] : _config$validationCod,
    shouldRenderCode = config.shouldRenderCode,
    rest = _objectWithoutProperties(config, _excluded);
  invariant(nameProp !== undefined || type === 'Divider' || type === 'Section' || type === 'Typography' || type === 'OCR' || !type, "name property is required for form item config (type: ".concat(type, ")"));
  invariant(!previewFormater || typeof previewFormater === 'function', 'previewFormater property should be a function');
  invariant(!shouldRender || typeof shouldRender === 'function', 'shouldRender property should be a function');
  var extraInitialValue = extraProps.initialValue,
    extraNormalize = extraProps.normalize,
    _extraProps$rules = extraProps.rules,
    extraRules = _extraProps$rules === void 0 ? [] : _extraProps$rules,
    extraExtra = extraProps.extra,
    extraHelp = extraProps.help,
    extraGetValueFromEvent = extraProps.getValueFromEvent,
    extraSpan = extraProps.span,
    extraValuePropName = extraProps.valuePropName,
    extraFullRow = extraProps.fullRow,
    extraHalfRow = extraProps.halfRow,
    extraMessageVariables = extraProps.messageVariables,
    extraRequiredMessage = extraProps.requiredMessage,
    extraPreviewFormater = extraProps.previewFormater,
    _extraProps$valueForm = extraProps.valueFormater,
    extraValueFormater = _extraProps$valueForm === void 0 ? function (value) {
      return value;
    } : _extraProps$valueForm,
    extraRequired = extraProps.required,
    _extraProps$requiredM = extraProps.requiredMark,
    requiredMark = _extraProps$requiredM === void 0 ? false : _extraProps$requiredM,
    className = extraProps.className,
    extraRest = _objectWithoutProperties(extraProps, _excluded2);
  var rules = calcRequired(required !== null && required !== void 0 ? required : extraRequired, form, requiredAsserts) ? [{
    required: type !== 'Declaration',
    message: requiredMessage || extraRequiredMessage
  }].concat(_toConsumableArray(propsRules)) : _toConsumableArray(propsRules);
  if (mergeRules) {
    rules.push.apply(rules, _toConsumableArray(extraRules));
  }
  var validateTriggers = ['onChange'];
  rules.forEach(function (_ref) {
    var validateTrigger = _ref.validateTrigger;
    if (validateTrigger) {
      Array.isArray(validateTrigger) ? validateTriggers.push.apply(validateTriggers, _toConsumableArray(validateTrigger)) : validateTriggers.push(validateTrigger);
    }
  });
  var isRequired = required || rules.find(function (rule) {
    return rule.required;
  });
  var name = calcNamePath(parentName, nameProp);
  var copiedValue = calcCopyValue(copyValue, form);
  var selectedValue = calcSelectValue(selectValue, form);
  var elementProps = {};
  Object.keys(_objectSpread(_objectSpread({}, extraRest), rest)).forEach(function (key) {
    elementProps[key.replace('element-', '')] = rest[key];
  });
  elementProps.disabled = calcDisabled(disabled, form) || copiedValue.disabled || selectedValue.disabled;
  if (dateLimitationType) {
    var rangeStart;
    var rangeEnd;
    if (dateLimitationType === 'absolute' && absoluteRangeStart) {
      rangeStart = moment(absoluteRangeStart).startOf('day');
    }
    if (dateLimitationType === 'relative' && (relativeRangeStart === null || relativeRangeStart === void 0 ? void 0 : relativeRangeStart.quantity) !== undefined) {
      var dependFieldValue = relativeRangeStart.dependField ? form === null || form === void 0 ? void 0 : form.getFieldValue(relativeRangeStart.dependField) : undefined;
      rangeStart = moment(dependFieldValue).add(relativeRangeStart.quantity, relativeRangeStart.type).startOf('day');
    }
    if (dateLimitationType === 'relative' && relativeRangeStart !== null && relativeRangeStart !== void 0 && relativeRangeStart.pattern) {
      var result = Array.from(relativeRangeStart.pattern.matchAll(/^(([-|+]{0,1}\d+)y){0,1}(([-|+]{0,1}\d+)m){0,1}(([-|+]{0,1}\d+)d){0,1}$/g));
      if (result.length) {
        var year = parseInt(result[0][2] || '0');
        var month = parseInt(result[0][4] || '0');
        var day = parseInt(result[0][6] || '0');
        var _dependFieldValue = relativeRangeStart.dependField ? form === null || form === void 0 ? void 0 : form.getFieldValue(relativeRangeStart.dependField) : undefined;
        rangeStart = moment(_dependFieldValue).add(year, 'year').add(month, 'month').add(day, 'day').startOf('day');
      }
    }
    if (dateLimitationType === 'absolute' && absoluteRangeEnd) {
      rangeEnd = moment(absoluteRangeEnd).endOf('day');
    }
    if (dateLimitationType === 'relative' && (relativeRangeEnd === null || relativeRangeEnd === void 0 ? void 0 : relativeRangeEnd.quantity) !== undefined) {
      var _dependFieldValue2 = relativeRangeEnd.dependField ? form === null || form === void 0 ? void 0 : form.getFieldValue(relativeRangeEnd.dependField) : undefined;
      rangeEnd = moment(_dependFieldValue2).add(relativeRangeEnd.quantity, relativeRangeEnd.type).endOf('day');
    }
    if (dateLimitationType === 'relative' && relativeRangeEnd !== null && relativeRangeEnd !== void 0 && relativeRangeEnd.pattern) {
      var _result = Array.from(relativeRangeEnd.pattern.matchAll(/^(([-|+]{0,1}\d+)y){0,1}(([-|+]{0,1}\d+)m){0,1}(([-|+]{0,1}\d+)d){0,1}$/g));
      if (_result.length) {
        var _year = parseInt(_result[0][2] || '0');
        var _month = parseInt(_result[0][4] || '0');
        var _day = parseInt(_result[0][6] || '0');
        var _dependFieldValue3 = relativeRangeEnd.dependField ? form === null || form === void 0 ? void 0 : form.getFieldValue(relativeRangeEnd.dependField) : undefined;
        rangeEnd = moment(_dependFieldValue3).add(_year, 'year').add(_month, 'month').add(_day, 'day').endOf('day');
      }
    }
    if (['DatePicker', 'BuddhistDatePicker'].includes(type)) {
      elementProps.disabledDate = function (current) {
        return +current < (rangeStart ? +rangeStart : Number.MIN_SAFE_INTEGER) || +current > (rangeEnd ? +rangeEnd : Number.MAX_SAFE_INTEGER);
      };
    }
    if (type === 'InputDate') {
      rules.push({
        validator: function validator(_, date) {
          if (!date) return Promise.resolve();
          var trimedDate = date.replaceAll(/\s/g, '');
          var format = elementProps.format ? elementProps.format.replaceAll(/\s/g, '') : 'DD/MM/YYYY';
          if (rangeStart && moment(trimedDate, format) < rangeStart) {
            return Promise.reject( /*#__PURE__*/_jsx(FormattedMessage, {
              id: "Please input a date after {date}",
              values: {
                date: rangeStart.format(format)
              }
            }));
          }
          if (rangeEnd && moment(trimedDate, format) > rangeEnd) {
            return Promise.reject( /*#__PURE__*/_jsx(FormattedMessage, {
              id: "Please input a date before {date}",
              values: {
                date: rangeEnd.format(format)
              }
            }));
          }
          return Promise.resolve();
        }
      });
    }
  }
  if (validationCode.length) {
    rules.push.apply(rules, _toConsumableArray(validationCode.map(function (_ref2) {
      var code = _ref2.code,
        errorMessage = _ref2.errorMessage;
      return {
        validator: function validator(_, value) {
          try {
            var fn = eval(code);
            var formValues = form === null || form === void 0 ? void 0 : form.getFieldsValue(true);
            var _result2 = fn(value, formValues, {
              moment: moment
            }, validationCodeExtraParams);
            return _result2 ? Promise.resolve() : Promise.reject(errorMessage);
          } catch (_unused) {
            return Promise.reject(errorMessage);
          }
        }
      };
    })));
  }
  return {
    colProps: {
      span: extraFullRow && fullRow === undefined || fullRow || extraHalfRow && halfRow === undefined || halfRow ? 24 : span || extraSpan || 12,
      xs: 24,
      sm: 24,
      md: extraFullRow && fullRow === undefined || fullRow || extraHalfRow && halfRow === undefined || halfRow ? 24 : span || 12,
      halfRow: halfRow === undefined ? extraHalfRow : halfRow
    },
    formItemProps: {
      name: name,
      className: className,
      initialValue: (valueFormater || extraValueFormater)(initialValue !== null && initialValue !== void 0 ? initialValue : extraInitialValue),
      copiedValue: copiedValue,
      selectedValue: selectedValue,
      normalize: normalize || extraNormalize,
      rules: rules,
      validateTrigger: _toConsumableArray(new Set(validateTriggers)),
      label: label ? /*#__PURE__*/_jsxs("div", {
        className: "igloo-form-label",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "igloo-form-label-text",
          children: [/*#__PURE__*/_jsx(Typography, {
            level: "body1",
            children: label
          }), isRequired && requiredMark && /*#__PURE__*/_jsx("span", {
            className: "igloo-form-label-required",
            children: "*"
          }), showOptional && /*#__PURE__*/_jsxs("span", {
            className: "igloo-form-label-optional",
            children: ["(", /*#__PURE__*/_jsx(FormattedMessage, {
              id: "Optional"
            }), ")"]
          })]
        }), extraLabel && /*#__PURE__*/_jsx("div", {
          className: "igloo-form-label-extra",
          children: typeof extraLabel === 'function' ? extraLabel(form) : extraLabel
        })]
      }) : null,
      getValueFromEvent: getValueFromEvent || extraGetValueFromEvent,
      getValueProps: getValueProps,
      extra: (extra || extraExtra) && /*#__PURE__*/_jsx(Typography, {
        level: "caption2",
        children: extra || extraExtra
      }),
      help: help || extraHelp,
      valuePropName: valuePropName || extraValuePropName,
      messageVariables: _objectSpread({
        label: label
      }, messageVariables || extraMessageVariables),
      dependencies: antdDependencies
    },
    elementProps: elementProps,
    display: !ignore && calcShouldRender(name, dependencies, asserts, shouldRender, shouldRenderCode, form),
    previewFormater: previewFormater || extraPreviewFormater
  };
};
export var calcDisabled = function calcDisabled(disabled, form) {
  if (!form || !disabled) return false;
  if (typeof disabled === 'boolean') return disabled;
  if (Array.isArray(disabled)) {
    var _iterator = _createForOfIteratorHelper(disabled),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var assert = _step.value;
        if (!testAssert(form, assert)) {
          return false;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return true;
  }
  return testAssert(form, disabled);
};
export var calcCopyValue = function calcCopyValue(copyValue, form) {
  if (!form) return {
    copied: false
  };
  if (!copyValue) return {
    copied: false
  };
  var copyFrom = copyValue.copyFrom,
    assert = copyValue.assert,
    disabled = copyValue.disabled;
  return testAssert(form, assert) ? {
    copied: true,
    value: form.getFieldValue(copyFrom),
    disabled: disabled
  } : {
    copied: false
  };
};
export var calcSelectValue = function calcSelectValue(selectValue, form) {
  if (!form) return {
    selected: false
  };
  if (!selectValue) return {
    selected: false
  };
  invariant(Array.isArray(selectValue), 'selectValue property should be an array.');
  var _iterator2 = _createForOfIteratorHelper(selectValue),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var select = _step2.value;
      var assert = select.assert,
        value = select.value,
        disabled = select.disabled;
      if (testAssert(form, assert)) {
        return {
          selected: true,
          value: value,
          disabled: disabled
        };
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return {
    selected: false
  };
};
export var calcShouldRender = function calcShouldRender(name) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var asserts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var shouldRender = arguments.length > 3 ? arguments[3] : undefined;
  var shouldRenderCode = arguments.length > 4 ? arguments[4] : undefined;
  var form = arguments.length > 5 ? arguments[5] : undefined;
  if (!form) return true;
  var _iterator3 = _createForOfIteratorHelper(dependencies),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var dep = _step3.value;
      if (!form.getFieldValue(dep)) {
        return false;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  if (typeof shouldRender === 'function') {
    return shouldRender(form);
  }
  if (shouldRenderCode) {
    var fn = eval(shouldRenderCode);
    if (typeof fn === 'function') {
      try {
        var value = form.getFieldValue(name);
        var values = form.getFieldsValue(true);
        return fn(value, values, {
          moment: moment
        });
      } catch (_unused2) {
        return false;
      }
    }
  }
  var _iterator4 = _createForOfIteratorHelper(asserts),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var assert = _step4.value;
      var rst = testAssert(form, assert);
      if (!rst) return rst;
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return true;
};
export var getRuleValidation = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, rule, values) {
    var lang,
      res,
      json,
      _ref4,
      conclusion,
      details,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          lang = _args.length > 3 && _args[3] !== undefined ? _args[3] : 'en-US';
          _context.next = 3;
          return fetch("".concat(url, "?lang=").concat(lang), {
            method: 'post',
            headers: {
              'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
              form: values || {},
              rules: Array.isArray(rule) ? rule : [rule]
            })
          });
        case 3:
          res = _context.sent;
          _context.next = 6;
          return res.json();
        case 6:
          json = _context.sent;
          _ref4 = json || {}, conclusion = _ref4.conclusion, details = _ref4.details;
          if (!conclusion) {
            _context.next = 10;
            break;
          }
          return _context.abrupt("return");
        case 10:
          if (!(conclusion === false)) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", details === null || details === void 0 ? void 0 : details.map(function (_ref5) {
            var err_message = _ref5.err_message,
              path = _ref5.path;
            return {
              name: path.split('.'),
              errors: [err_message]
            };
          }));
        case 12:
          return _context.abrupt("return", Promise.reject(json.message));
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getRuleValidation(_x, _x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();